import React, { forwardRef } from 'react';

import { Button as MuiButton } from '@mui/material';

import styles from './buttonV2.style';

const ButtonV2 = forwardRef(
  (
    {
      children,
      variant = 'contained',
      size = 'medium',
      loading = false,
      width,
      type = 'button',
      ...props
    },
    ref
  ) => {
    return (
      <MuiButton
        variant={variant}
        sx={{
          ...styles.button({ size, color: props.color }),
          ...(variant === 'outlined' &&
            styles.outlinedButton({ size, color: props.color })),
          ...(variant === 'text' && {
            ...styles.textButton({ color: props.color, size }),
          }),
          ...(variant === 'secondary' && styles.secondaryButton({ size })),
          ...(width && { width }),
        }}
        {...props}
        size={size}
        loading={loading}
        ref={ref}
        type={type}
      >
        {children || 'Button'}
      </MuiButton>
    );
  }
);

export default ButtonV2;
